import Vue from 'vue';
import InputCountry from '../../../core/input/country/input-country';

export default function () {
  const popupOffer = document.querySelector('.popup-offer');

  if (popupOffer) {
    window.VueEvent = new Vue();
    new Vue({
      el: popupOffer,
      delimiters: ['${', '}}'],
      data: {
        showError: false,
        phoneNumber: '',
        formData: {
          phone: '',
        },
        showForm: true,
        widgetId: window.defaultValues.widgetId,
        showPopup: false,
      },
      components: {
        InputCountry,
      },
      methods: {
        closePopup() {
          this.showPopup = false;
        },
        completeForm(phone) {
          this.formData.phone = phone;
          if (this.formData.phone.length === 17) {
            this.showError = false;
            this.config = {
              widgetId: this.widgetId,
              insecureContext: {
                phone: this.formData.phone,
              },
            };
          }
        },
        setChange(event) {
          if (event.target.type === 'tel') {
            this.phoneNumber = event.target.value.replace(/[^\d]/g, '');
          }
        },
        submit() {
          if (this.phoneNumber.length < 11) {
            this.showError = true;
          }

          if (this.config) {
            window.TextBack.SDK.initWidget(this.config)
              .then((widget) => {
                // widget.getEnabledChannels() - для проверки доступных каналов с подписками
                widget.subscribe('whatsappb');
                this.showForm = false;
              });
          }
        },
      },
      mounted() {
        setTimeout(() => {
          this.showPopup = true;
        }, 5000);
      },
    });
  }
}



// WEBPACK FOOTER //
// ./blocks/popup/offer/popup-offer.js